// apps/admin/src/components/AdminHeader.tsx
import React, { useEffect, useState } from "react";
import gcLogo from "@ui/assets/gclogo.png";
import {
  PlusIcon,
  ArrowLeftOnRectangleIcon,
  ChevronDownIcon,
  ChatBubbleLeftRightIcon,
} from "@heroicons/react/24/outline";
import { getSupabaseClient } from "../lib/supabase";

const DEFAULT_AVATAR =
  "data:image/png;base64,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";

type AdminHeaderProps = {
  title?: string;
  rightSlot?: React.ReactNode;
  onSignOut?: () => void;
  onShareInviteClick?: () => void;
  onChatClick?: () => void;
  onMenuClick?: () => void;
  hasUnreadMessages?: boolean;
  unreadCount?: number;
  showUserProfile?: boolean;
  userInitials?: string;
  userName?: string;
  userRole?: string;
  userAvatar?: string;
  variant?: "login" | "register" | "onboarding";
  stepIndex?: number;
  totalSteps?: number;
};

export function AdminHeader({
  title = "GuidesCollective Admin",
  rightSlot,
  onSignOut,
  onShareInviteClick,
  onChatClick,
  onMenuClick,
  hasUnreadMessages = false,
  unreadCount = 0,
  showUserProfile = true,
  userInitials = "GC",
  userName,
  userRole = "Admin",
  userAvatar,
  variant,
  stepIndex = 0,
  totalSteps = 4,
}: AdminHeaderProps) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [userProfile, setUserProfile] = useState<{
    name?: string;
    initials?: string;
    role?: string;
    avatar?: string;
  }>({
    name: userName,
    initials: userInitials,
    role: userRole,
    avatar: userAvatar,
  });

  useEffect(() => {
    if (!showUserProfile) return;

    const fetchUserProfile = async () => {
      try {
        const supabase = getSupabaseClient();
        const {
          data: { user },
          error: authError,
        } = await supabase.auth.getUser();

        if (authError || !user) return;

        const { data: profile, error: profileError } = await supabase
          .from("profiles")
          .select("full_name")
          .eq("id", user.id)
          .single();

        if (!profileError && profile) {
          const fullName = profile.full_name || "Admin";
          const nameParts = fullName.trim().split(" ");
          const initials =
            nameParts.length >= 2
              ? `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`
              : nameParts[0]?.[0] || "A";

          setUserProfile((prev) => ({
            ...prev,
            name: fullName,
            initials: initials.toUpperCase(),
          }));
        }
      } catch (error) {
        console.error("Error fetching admin profile:", error);
      }
    };

    fetchUserProfile();
  }, [showUserProfile]);

  useEffect(() => {
    if (!showUserProfile) {
      setIsDropdownOpen(false);
    }
  }, [showUserProfile]);

  const closeDropdown = () => setIsDropdownOpen(false);

  const handleSignOut = () => {
    if (onSignOut) {
      onSignOut();
    }
    closeDropdown();
  };

  const resolvedVariant = variant ?? (showUserProfile ? undefined : "login");

  const renderLoggedOutContent = () => {
    if (resolvedVariant === "login") {
      return null;
    }

    if (resolvedVariant === "register") {
      return (
        <div className="text-sm text-white mr-6">
          Already have an account?{" "}
          <a href="/login" className="font-medium text-white hover:underline">
            Sign in
          </a>
        </div>
      );
    }

    return (
      <div className="text-sm text-[#FEF6D6] flex items-center gap-4 mr-6">
        <span>
          Step {stepIndex + 1} of {totalSteps}
        </span>
        <a href="#" className="hover:underline">
          Need help?
        </a>
        <a href="mailto:support@guidescollective.com" className="hover:underline">
          Contact Support
        </a>
        {onSignOut && (
          <button
            onClick={handleSignOut}
            className="inline-flex items-center gap-1 text-white hover:underline"
          >
            <ArrowLeftOnRectangleIcon className="h-4 w-4" />
            Logout
          </button>
        )}
      </div>
    );
  };

  return (
    <header className="flex items-center justify-between px-4 lg:px-6 py-4 border-b border-[#2C2731] bg-[#2C2731] text-[#FEF6D6] h-16">
      <div className="flex items-center gap-3 lg:ml-6">
        {onMenuClick && (
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-lg text-[#FEF6D6]/80 hover:text-[#FEF6D6] hover:bg-[#403851] transition-colors"
            aria-label="Open menu"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        )}
        <div className="h-10 flex items-center">
          <img src={gcLogo} alt="GuidesCollective Logo" className="h-10 w-auto" />
        </div>
        {title && (
          <span className="hidden sm:inline text-sm font-medium text-[#FEF6D6]/80">{title}</span>
        )}
      </div>

      {showUserProfile ? (
        <div className="flex items-center gap-2 lg:gap-4 lg:mr-6">
          {onChatClick && (
            <button
              onClick={onChatClick}
              className="relative p-2 rounded-full transition-colors hover:bg-[#403851]"
              aria-label="Messages"
            >
              <ChatBubbleLeftRightIcon className="h-6 w-6 text-[#FEF6D6]" />
              {hasUnreadMessages && (
                <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[9px] font-bold text-white">
                  {unreadCount > 9 ? "9+" : unreadCount || ""}
                </span>
              )}
            </button>
          )}

          {onShareInviteClick && (
            <button
              onClick={onShareInviteClick}
              className="inline-flex items-center gap-2 h-9 px-4 rounded-lg bg-[#FFFCEF] text-[#2C2731] hover:bg-[#F2EAC3] shadow-sm"
            >
              <PlusIcon className="h-4 w-4" />
              <span className="text-sm font-medium">Share Your Link</span>
            </button>
          )}

          {rightSlot}

          <div className="relative">
            <button
              onClick={() => setIsDropdownOpen((prev) => !prev)}
              className="flex items-center gap-3 rounded-md p-2 transition-colors hover:bg-[#403851]"
            >
              <img
                src={userProfile.avatar || DEFAULT_AVATAR}
                alt="User Avatar"
                className="h-9 w-9 rounded-full ring-1 ring-white/20"
              />
              <div className="hidden sm:block text-right leading-tight">
                <div className="text-sm font-medium text-white ph-mask">
                  {userProfile.name || "Admin"}
                </div>
                <div className="text-xs text-gray-200">
                  {userProfile.role || userRole}
                </div>
              </div>
              <ChevronDownIcon className="hidden sm:block h-4 w-4 text-white" />
            </button>

            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
                <div className="py-1">
                  {onSignOut && (
                    <button
                      onClick={handleSignOut}
                      className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                    >
                      <ArrowLeftOnRectangleIcon className="h-4 w-4" />
                      Sign Out
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-4 mr-6">
          {rightSlot}
          {renderLoggedOutContent()}
        </div>
      )}
    </header>
  );
}
